import { render } from "./TransactionDetail.vue?vue&type=template&id=2faf5c9c&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"

import "./TransactionDetail.vue?vue&type=style&index=0&id=2faf5c9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faf5c9c"]])

export default __exports__